<template>
  <div class="bg-white rounded-lg shadow">
    <div class="flex flex-col p-4 h-full space-y-2">
      <div class="w-full h-10 bg-gray-100 animate-pulse"></div>
      <div class="w-full h-32 bg-gray-100 animate-pulse"></div>
    </div>
  </div>

</template>
